import React, { useState } from "react";
import { Formik, Form, FormikValues, FormikHelpers } from "formik";
import { Stack, StackItem } from "office-ui-fabric-react/lib/Stack";
import { useTranslation } from "react-i18next";
import FormBtns from "../../../../common/layout/form/NewFormBtns";
import ActivityIndicator from "../../../../common/layout/ActivityIndicator";
import ErrorMessage from "../../../../common/layout/form/ErrorMessage";
import { useCancelForm } from "../../../hooks/useCancelForm";
import MultiDepartmentRadio from "./MultiDepartmentRadio";
import { containerS, radioContainer } from "../../../styles/basicInfoForm.styles";
import { useBasicInfoForm } from "../../../hooks/useBasicInfoForm";
import DisplayText from "../displayData/DisplayText";
import FormHeader from "../FormHeader";
import { validationSchemaCompanyBasicInfo, validationSchemaNonPolishCompanyBasicInfo } from "../../../../auth/actions/validationSchema";
import NewFormField from "../../../../common/layout/form/NewFormField";
import FormDropDown from "../../../../common/layout/form/FormDropDown";
import { IResetForm } from "../../../../common/models/resetForm.type";
import EditableListFormClient from "./EditableListFormClient";
import { LangEnum } from "../../../../common/enums/lang.enum";

const BasicInfoForm: React.FC = () => {
    const { t } = useTranslation("admin");
    const cancel = useCancelForm();
    const [specialPrices, setSpecialPrices] = useState<any[]>([])
    const {
        initValues,
        handleSubmit,
        isLoading,
        readOnlyData,
    } = useBasicInfoForm();

    const handleEdit = async (values: FormikValues, formikHelpers: IResetForm) => {
        const { resetForm } = formikHelpers;
        const serializedSpecialPrices = JSON.stringify({
            specialPrices: specialPrices.map((price: any) => ({
                id: price.id,
                value: price.value,
                dateFrom: price.dateFrom,
                dateTo: price.dateTo,
                orderTypeItemId: price.orderTypeItemId
            }))
        });
        await handleSubmit(values, serializedSpecialPrices, { resetForm });
    };

    return (
        <Formik initialValues={initValues}
            onSubmit={handleEdit}
            enableReinitialize={true}
            validationSchema={readOnlyData.country == LangEnum.Polish ? validationSchemaCompanyBasicInfo : validationSchemaNonPolishCompanyBasicInfo}>
            {({ handleSubmit }) => (
                <>
                    <Form translate="yes" onSubmit={handleSubmit}>
                        <Stack styles={containerS} verticalAlign="space-between" verticalFill>
                            <FormHeader text={t("nav.panelEditBasicInfo") as string} />
                            <DisplayText name={t("nav.companyName") as string} value={readOnlyData.name} />
                            <DisplayText name={t("nav.nip") as string} value={readOnlyData.taxNumber} />
                            <DisplayText name={t("nav.country") as string} value={readOnlyData.countryStr} />
                            <NewFormField name="shortName" label={t("nav.shortName") as string} required={false} />
                            <NewFormField name="bdoNumber" label={t("nav.bdo") as string} required={false} />
                            <NewFormField name="city" label={t("nav.city") as string} />
                            <NewFormField name="street" label={t("nav.street") as string} />
                            <NewFormField name="postalCode" label={t("nav.postalCode") as string} />
                            <FormDropDown
                                name={"paymentType"}
                                headerText={t("nav.paymentType") as string}
                                options={[{ key: 1, text: t("nav.paymentCash") },
                                { key: 2, text: t("nav.paymentTransfer") }]}
                            />
                            <StackItem>
                                <div className={radioContainer}>
                                    <MultiDepartmentRadio
                                        name="multiDepartment"
                                        label={t("nav.multiDepartment") as string}
                                        options={[
                                            { key: "yes", text: t("nav.optionYes") },
                                            { key: "no", text: t("nav.optionNo") },
                                        ]}
                                    />
                                </div>
                            </StackItem>
                        </Stack>
                        <Stack styles={containerS} verticalAlign="space-between" verticalFill>
                            <FormHeader text={t("nav.addPriceSection") as string} />
                            <EditableListFormClient
                                setSpecialPrices={setSpecialPrices}
                                specialPrices={specialPrices}
                                companyId={initValues ? initValues.id : null}
                            />
                        </Stack>
                        <div>
                            <FormBtns
                                cancelForm={cancel}
                                submitBtnText={t("nav.save") as string}
                                disabled={isLoading}
                            />
                        </div>
                        <div>{isLoading ? <ActivityIndicator /> : <ErrorMessage />}</div>
                    </Form>
                </>
            )}
        </Formik>
    );
};

export default BasicInfoForm;